import { Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";

const ProtectedCustomerRoute = ({ children }) => {
  const { isLoggedIn, user, authLoading } = useContext(AuthContext);
  const location = useLocation();

  if (authLoading) {
    return (
      <div style={{ padding: "120px 24px", textAlign: "center", fontFamily: "Montserrat" }}>
        Loading your account...
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <Navigate
        to={`/Login?returnUrl=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  if (user?.role !== "customer") {
    return <Navigate to="/market" replace />;
  }

  return children;
};

export default ProtectedCustomerRoute;
